const state = () => ({
  dialogButtons: [],
  dialogTitle: '',
  dialogLeftHeaderIcon: '',
  dialogHeaderType: 'information',
  verificationResult: '',
  dialogLoading: false
});

const getters = {
  dialogButtons(state) {
    return state.dialogButtons;
  },
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogLeftHeaderIcon(state) {
    return state.dialogLeftHeaderIcon;
  },
  dialogHeaderType(state) {
    return state.dialogHeaderType;
  },
  verificationResult(state) {
    return state.verificationResult;
  },
  dialogLoading(state) {
    return state.dialogLoading;
  }
};

const mutations = {
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogLeftHeaderIcon(state, payload) {
    state.dialogLeftHeaderIcon = payload;
  },
  setDialogHeaderType(state, payload) {
    state.dialogHeaderType = payload;
  },
  setVerificationResult(state, payload) {
    state.verificationResult = payload;
  },
  setDialogLoading(state, payload) {
    state.dialogLoading = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogLeftHeaderIcon({ commit }, payload) {
    commit('setDialogLeftHeaderIcon', payload);
  },
  setDialogHeaderType({ commit }, payload) {
    commit('setDialogHeaderType', payload);
  },
  setVerificationResult({ commit }, payload) {
    commit('setVerificationResult', payload);
  },
  setDialogLoading({ commit }, payload) {
    commit('setDialogLoading', payload);
  }
};

export const phoneVerification = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
